'use client';
import { useEffect, useRef, useState } from 'react';
import ShopletterDialog from "./shopLetterButton";
import { useTranslations } from "next-intl";

const Nshop = () => {
  const t = useTranslations('ShopLetter');
  const containerRef = useRef<HTMLDivElement>(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <div 
      ref={containerRef} 
      className="relative md:h-80 overflow-hidden"
     
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10"></div>
      
      {/* Content */}
      <div className="relative z-20 mx-6 md:mx-20 flex custom:mx-96 justify-center md:justify-between gap-10 py-20 items-center flex-col">
        <h2 className="text-2xl md:text-4xl custom:text-5xl font-extrabold uppercase text-yel text-center drop-shadow-lg">
          {t('title')}
        </h2>
        <ShopletterDialog />
      </div>
    </div>
  );
};

export default Nshop;